import React, { useEffect } from "react";
import Heading from "../components/common/Heading";

export default function TermsPage() {
  useEffect(() => {
    document.title = "Terms & Conditions | HariKunj Resort & Hotel Jodhpur";
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Heading heading="Terms & Conditions" title="Terms & Conditions" subtitle="Resort Policy & Guidelines" />

      <main className="container my-5 py-3" style={{ maxWidth: "960px" }}>
        <div 
          className="p-4 p-md-5 rounded-4 shadow-sm" 
          style={{ 
            background: "#FFFFFF", 
            border: "1px solid rgba(212, 175, 55, 0.3)",
            color: "#0B1D37" 
          }}
        >
          <div className="text-center mb-5">
            <h1 className="h2 fw-bold mb-3" style={{ fontFamily: "'Cinzel Decorative', serif", color: "#0B1D37" }}>
              HariKunj Resort &amp; Hotel Terms &amp; Conditions
            </h1>
            <p className="text-muted italic">Last Updated: January 2026 | Effective for all Guest Stays &amp; Event Bookings</p>
            <div style={{ width: "60px", height: "2px", background: "#FEA116", margin: "15px auto" }} />
          </div>

          <section className="mb-4">
            <h2 className="h4 fw-bold text-primary mb-3">1. Reservation &amp; Check-In Policy</h2>
            <p className="lh-lg">
              Welcome to <strong>HariKunj Resort &amp; Hotel Jodhpur</strong>. By making a reservation or utilizing our facilities, guests agree to abide by the rules outlined herein.
            </p>
            <ul className="lh-lg">
              <li><strong>Standard Check-in Time:</strong> 12:00 PM (Noon)</li>
              <li><strong>Standard Check-out Time:</strong> 11:00 AM</li>
              <li><strong>Valid Identification:</strong> Primary guests must present valid government-issued photo identification (Aadhaar Card, Passport, Voter ID, or Driving License) upon check-in. PAN Cards are not accepted per local regulation.</li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="h4 fw-bold text-primary mb-3">2. Payment &amp; Cancellation Terms</h2>
            <p className="lh-lg">
              Advance payments are required to confirm room bookings and event lawn reservations.
            </p>
            <ul className="lh-lg">
              <li><strong>Cancellation &gt; 7 Days Prior to Arrival:</strong> 100% refund (minus administrative transaction charges).</li>
              <li><strong>Cancellation 3 - 7 Days Prior:</strong> 50% retention charge applies.</li>
              <li><strong>Cancellation &lt; 72 Hours or No-Show:</strong> 100% room charge will be retained.</li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="h4 fw-bold text-primary mb-3">3. Event Lawn &amp; Courtyard Regulations</h2>
            <p className="lh-lg">
              HariKunj Resort hosts weddings, corporate retreats, and royal celebrations on our manicured peacock lawns.
            </p>
            <ul className="lh-lg">
              <li>Loud music or outdoor amplification must comply with local government noise curfew regulations (strictly prohibited after 10:00 PM).</li>
              <li>Damages to resort property, flora, or pool installations during private functions will be billed directly to the event host.</li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="h4 fw-bold text-primary mb-3">4. Guest Safety &amp; Swimming Pool Rules</h2>
            <p className="lh-lg">
              Our outdoor pool is available for in-house resort guests. Children under 12 years of age must be accompanied by an adult guardian at all times. Proper swimwear is compulsory.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h4 fw-bold text-primary mb-3">5. Contact &amp; Legal Inquiries</h2>
            <p className="lh-lg">
              For questions regarding our terms, please reach out to our resort reception desk:
            </p>
            <p className="fw-bold mb-1">HariKunj Resort &amp; Hotel</p>
            <p className="mb-1">Gopal Badi, Chopasni, Jodhpur, Rajasthan 342008</p>
            <p className="mb-1">Phone: +91 9602588882 / +91 9602588883</p>
            <p className="mb-0">Email: reservation@harikunjresort.com</p>
          </section>
        </div>
      </main>
    </>
  );
}
